<section>
  <div class="page-filters">
    <kendo-gridlayout [rows]="['auto']" [gap]="{ rows: 5, cols: 16 }" [cols]="['repeat(5,minmax(0,1fr))']">
      <kendo-gridlayout-item class="mb-0">
        <app-investigation-multi-select-kendo label="Investigation ID" placeholder="Search ID"
          [selectedIds]="filterByIdValue(filterTypes.IdsIn)" (enteredPressed)="applyFilter()"
          (selectionChanged)="setFilters($event, filterTypes.IdsIn)"></app-investigation-multi-select-kendo>
      </kendo-gridlayout-item>
      <kendo-gridlayout-item class="mb-0">
        <app-insured-multi-select-kendo placeholder="Search insured name"
          [selectedId]="filterByIdValue(filterTypes.Insured)" (enteredPressed)="applyFilter()"
          (selectionChanged)="setFilters($event, filterTypes.Insured)"></app-insured-multi-select-kendo>
      </kendo-gridlayout-item>
      <kendo-gridlayout-item class="mb-0">
        <div class="kendo-formfield left-search-icon">
          <kendo-label text=""></kendo-label>
          <div style="position: relative;">
            <i class="fa fa-search" aria-hidden="true"></i>
            <kendo-textbox [value]="filterValue(filterTypes.LossCity) || ''" (keydown.enter)="applyFilter()"
              (valueChange)="setFilters($event, filterTypes.LossCity)" placeholder="Search loss city" fillMode="outline"
              [clearButton]="false">
            </kendo-textbox>
          </div>
        </div>
      </kendo-gridlayout-item>
      <kendo-gridlayout-item class="mb-0">
        <div class="kendo-formfield left-search-icon">
          <kendo-label text=""></kendo-label>
          <div style="position: relative;">
            <i class="fa fa-search" aria-hidden="true"></i>
            <kendo-textbox [value]="filterValue(filterTypes.StreetAddress) || ''" (keydown.enter)="applyFilter()"
              (valueChange)="setFilters($event, filterTypes.StreetAddress)" placeholder="Search loss street address"
              fillMode="outline" [clearButton]="false">
            </kendo-textbox>
          </div>
        </div>
      </kendo-gridlayout-item>
      <kendo-gridlayout-item class="filter-actions mb-0" [colSpan]="1" [col]="0" [row]="0">
        <div class="applied-filter mr-16">
          <kendo-label text=""></kendo-label>
          <div>
            <kendo-button kendoButton themeColor="primary" fillMode="solid" size="medium" [disabled]="!filters?.length"
              (click)="applyFilter()">Apply
              Filters</kendo-button>
          </div>
        </div>
        <div class="clear-filter mt-5">
          <kendo-label text=""></kendo-label>
          <div>
            <kendo-button kendoButton themeColor="primary" fillMode="link" size="medium" (click)="clearFilter()">Clear
              All</kendo-button>
          </div>
        </div>
      </kendo-gridlayout-item>
      <kendo-gridlayout-item>
        <app-contact-select-kendo (selectionChanged)="setFilters($event?.id, filterTypes.Contact)"
          [bypassPermission]="true" (enteredPressed)="applyFilter()" [contactId]="filterValue(filterTypes.Contact)"
          [contactFilters]="contactFilters" placeholder="Select contact name"></app-contact-select-kendo>
      </kendo-gridlayout-item>
    </kendo-gridlayout>
    <section>
      <kendo-grid [data]="{
        data: (dataSource?.contents$ | async) || [],
        total: (dataSource?.pageInfo$ | async)?.totalCount
      }" [pageSize]="pageOptions?.limit" [skip]="pageOptions?.offset" [pageable]="{
          buttonCount: 6,
          type: 'numeric',
          pageSizes: [5, 10, 25, 100],
          previousNext: true,
          responsive: true,
          position: 'bottom'
        }" (pageChange)="pageOptions?.paginate($event)" [sortable]="true" [sort]="sort"
        (sortChange)="sortChange($event)" [navigatable]="false">
        <kendo-grid-column field="NEFCO_NUMBER" title="ID #" [width]="10" [sortable]="true"
          [headerClass]="'sort-header'">
          <ng-template kendoGridCellTemplate let-dataItem>
            <a target="_blank" [routerLink]="['/investigations/', dataItem?.id]" tel="" class="text-decoration">
              {{dataItem?.nefcoNumber || 'Unassigned'}}</a>
          </ng-template>
        </kendo-grid-column>
        <!-- priority -->
        <kendo-grid-column field="PRIORITY" title="Priority" [width]="7" [sortable]="true"
          [headerClass]="'sort-header'">
          <ng-template kendoGridCellTemplate let-dataItem>
            <kendo-badge class="{{
      'fw600 ' +
        (dataItem?.Priority?.name === 'Low' ||
        dataItem?.Priority?.name === 'Medium'
          ? 'fcolor'
          : '')
    }}" position="none" size="medium" rounded="full" themeColor="{{
      dataItem?.Priority?.name === 'Low'
        ? 'tertiary'
        : dataItem?.Priority?.name === 'Medium'
        ? 'warning'
        : dataItem?.Priority?.name === 'High'
        ? 'error'
        : ''
    }}">{{ dataItem?.Priority?.name }}</kendo-badge>
            <ng-container *ngIf="!dataItem?.Priority?.name">-</ng-container>
          </ng-template>
        </kendo-grid-column>
        <!-- lossDate -->
        <kendo-grid-column field="LOSS_DATE" title="Loss Date" [width]="10" [sortable]="true"
          [headerClass]="'sort-header'">
          <ng-template kendoGridCellTemplate let-dataItem>
            <span>{{
              dataItem?.lossDate | customDate : "MM/dd/yyyy" : true
              }}</span>
          </ng-template>
        </kendo-grid-column>
        <!-- riskType -->
        <kendo-grid-column field="RiskType" title="Risk Type" [width]="10" [sortable]="false" class="font-weight600"
          [headerClass]="'nocursor'">
          <ng-template kendoGridCellTemplate let-dataItem>
            <div class="risk-type">
              <img class="risk-type-img" src="{{ getIcon(dataItem?.RiskType?.name) }}" />
              <span class="text-overflow">&nbsp;{{ dataItem?.RiskType?.name }}</span>
            </div>
          </ng-template>
        </kendo-grid-column>
        <!-- LossAddress -->
        <kendo-grid-column field="lossAddress" title="Loss Address" [width]="15" [sortable]="false"
          [headerClass]="'nocursor'">
          <ng-template kendoGridCellTemplate let-dataItem>
            <ng-container *ngIf="dataItem?.LossAddress; else locationElse">
              <ng-container *ngIf="dataItem?.LossAddress?.address1">
                <span>{{ dataItem?.LossAddress?.address1 }}<br /></span>
              </ng-container>
              <ng-container *ngIf="dataItem?.LossAddress?.address2">
                <span>{{ dataItem?.LossAddress?.address2 }}<br /></span>
              </ng-container>
              <ng-container *ngIf="dataItem?.LossAddress?.address3">
                <span>{{ dataItem?.LossAddress?.address3 }}<br /></span>
              </ng-container>
              <span>
                {{
                dataItem?.LossAddress?.city
                ? dataItem?.LossAddress?.city + ","
                : ""
                }}
                {{ dataItem?.LossAddress?.state }}
                {{ dataItem?.LossAddress?.postal }}
              </span>
            </ng-container>
            <ng-template #locationElse>-</ng-template>
          </ng-template>
        </kendo-grid-column>
        <!-- Insured -->
        <kendo-grid-column field="Insured" title="Insured" [width]="10" [sortable]="false" [headerClass]="'nocursor'">
          <ng-template kendoGridCellTemplate let-dataItem>
            <span>{{ dataItem?.Insured | insuredName }}<br /></span>
            <span class="phone-number" *ngIf="dataItem?.Insured?.Phones">{{
              (dataItem?.Insured?.Phones | primaryAssociation)?.number
              | phoneFormat : "US"
              }}</span>
          </ng-template>
        </kendo-grid-column>
        <!-- Client -->
        <kendo-grid-column field="Client" title="Client" [width]="15" [sortable]="false" [headerClass]="'nocursor'">
          <ng-template kendoGridCellTemplate let-dataItem>
            <ng-container *ngIf="
          !dataItem?.Client?.firstName &&
            !dataItem?.Client?.lastName &&
            !dataItem?.ClientBranch;
          else cliendInfo
        ">-</ng-container>
            <ng-template #cliendInfo>
              <span *ngIf="dataItem?.Client">{{ dataItem?.Client | fullName }} <br /></span>
              <span *ngIf="dataItem?.ClientBranch?.Company?.name">{{ dataItem?.ClientBranch?.Company?.name
                }}<br /></span>
              <span> {{ dataItem?.ClientBranch?.name }}</span>
            </ng-template>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="InvestigationStaff" title="Assigned" [width]="15" [sortable]="false"
          [headerClass]="'nocursor'">
          <ng-template kendoGridCellTemplate let-dataItem>
            <ng-container *ngIf="dataItem?.InvestigationStaff?.length > 0">
              <div class="dflex assignedmore">
                <div class="assigned">
                  <span *ngFor="
              let staff of dataItem?.assigned | slice : 0 : 2;
              let i = index
            ">
                    <kendo-badge *ngIf="i < 2" class="{{
                'fw600 assigned-badge' +
                  (i === 1 ? ' fcolor' : '') +
                  (i === 1 ? ' mt-5' : '')
              }}" position="none" size="medium" rounded="full" themeColor="{{
                i === 0 ? 'primary' : i === 1 ? 'tertiary' : ''
              }}">
                      <span>{{ staff.User | fullName }}</span>
                    </kendo-badge>
                  </span>
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="dataItem?.InvestigationStaff?.length === 0">-</ng-container>
          </ng-template>
        </kendo-grid-column>
        <!-- Status -->
        <kendo-grid-column field="status" title="Status" [width]="5" [sortable]="false" [headerClass]="'nocursor'">
          <ng-template kendoGridCellTemplate let-dataItem>
            <span class="text-overflow">
              {{
              dataItem?.status === "PENDING"
              ? "Pending"
              : dataItem?.status === "" || !dataItem?.status
              ? "-"
              : investigationStatusNames[dataItem?.status]
              }}
            </span>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column field="ACTION" title="Action" [width]="5" [sortable]="false" [headerClass]="'nocursor'">
          <ng-template kendoGridCellTemplate let-dataItem>
            <button class="actions" kendoButton themeColor="secondary" fillMode="link"
              (click)="openCommentModal(dataItem)" [iconClass]="'fa-solid fa-comment'" [size]="'large'"></button>
          </ng-template>
        </kendo-grid-column>
        <ng-template kendoGridNoRecordsTemplate>
          <div class="no-data-wrapper">
            <p class="no-data">
              <ng-container *ngIf="dataSource?.lastFilters?.length else noFilter">No records found.</ng-container>
              <ng-template #noFilter>Select from the filter
                criteria above to populate closed investigations</ng-template>
          </div>
        </ng-template>
      </kendo-grid>
    </section>
  </div>
  <ng-template #noValue>-</ng-template>
